import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/quality_reports/process_by_main_rep/list_templates/agro_exporter_process/${agro_exporter_id}/${agro_exporter_process_id}`
    );
  },
  fetchQualityTemplateMainRes(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/quality_reports/process_by_main_rep/list_templates/${agro_exporter_id}/${agro_exporter_process_id}`
    );
  }
};
